import {inject} from "@angular/core";
import {delay, map} from "rxjs/operators";
import {CanActivateFn, Router} from '@angular/router';
import {AppStateService} from "@app/shared/services/app-state.service";

export const canCreateBlogGuard: CanActivateFn = () => {
  const router = inject(Router);
  const appStateService = inject(AppStateService);

  return appStateService.user$
    .pipe(
      delay(500),
      map(() => {
        if (appStateService.blogCreateUsers.includes(appStateService.user?.email || '')) {
          return true;
        }

        router.navigate(['/']);
        return false;
      })
    )

};

